import { NgModule } from '@angular/core';
import { DECLARATIVE_FORMS_TEMPLATE_BUILDER_TOKEN } from '@fmnts/declarative-forms';
import { FundraiserTemplateService } from './common/fundraiser-template.service';

/**
 * Module that provides the common templating functionality
 * for declarative forms.
 */
@NgModule({
  providers: [
    {
      provide: DECLARATIVE_FORMS_TEMPLATE_BUILDER_TOKEN,
      useClass: FundraiserTemplateService,
      multi: true,
    },
  ],
})
export class TemplateModule {}
